import { render, staticRenderFns } from "./BodyDonnees.vue?vue&type=template&id=b69391ea&scoped=true"
import script from "./BodyDonnees.vue?vue&type=script&lang=js"
export * from "./BodyDonnees.vue?vue&type=script&lang=js"
import style0 from "./BodyDonnees.vue?vue&type=style&index=0&id=b69391ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69391ea",
  null
  
)

export default component.exports